import CircularProgress from "@mui/material/CircularProgress";

const SubmitButton = ({ isLoading, loadingText, btnText }) => {
  return (
    <div className="login-button">
      <button
        type="submit"
        className="theme-button mt-2 w-100"
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <CircularProgress size={20} />
            {loadingText}
          </>
        ) : (
          <>{btnText}</>
        )}
      </button>
    </div>
  );
};

export default SubmitButton;
